export const RCTI_DATE_TIME_ZONE = "Australia/Sydney";
export function rctiToday(now = new Date()) {
  const parts = new Intl.DateTimeFormat("en-AU", {
    timeZone: RCTI_DATE_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(now);
  const value = (type) => parts.find((part) => part.type === type).value;
  return `${value("year")}-${value("month")}-${value("day")}`;
}
export function rctiCalendarDate(value) {
  if (!value || (typeof value !== "string" && !(value instanceof Date)))
    return "";
  const text =
    value instanceof Date
      ? Number.isFinite(value.getTime())
        ? value.toISOString()
        : ""
      : String(value);
  const day = text.slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day)) return "";
  const parsed = new Date(`${day}T00:00:00.000Z`);
  return Number.isFinite(parsed.getTime()) &&
    parsed.toISOString().slice(0, 10) === day
    ? day
    : "";
}
export function rctiEarliestSupplyDate(now = new Date()) {
  return new Date(
    new Date(`${rctiToday(now)}T00:00:00Z`).getTime() - 28 * 86400000
  )
    .toISOString()
    .slice(0, 10);
}
const invalid = (message) => {
  throw Object.assign(new Error(message), { statusCode: 400 });
};
export function validateRctiSupplyDate(
  value,
  now = new Date(),
  adjustment = false
) {
  const day = rctiCalendarDate(value);
  if (!day) invalid("Choose a valid supply date.");
  if (day > rctiToday(now)) invalid("Supply date cannot be in the future.");
  if (!adjustment && day < rctiEarliestSupplyDate(now))
    invalid(
      "Supply date must be within the last 28 days. Ask the supplier for their tax invoice if the issue window has passed."
    );
  return day;
}
export function prepareRctiDates(post, current, now = new Date()) {
  const adjustment = Boolean(
    current &&
      (current.issuedAt ||
        Number(current.emailSent) > 0 ||
        Number(current.version) > 1)
  );
  const saved = adjustment && rctiCalendarDate(current.supplyDate);
  if (saved && post.supplyDate && rctiCalendarDate(post.supplyDate) !== saved)
    invalid("An adjustment must keep the original supply date.");
  post.supplyDate = validateRctiSupplyDate(
    saved || post.supplyDate,
    now,
    adjustment
  );
  post.rctiDate = `${rctiToday(now)}T00:00:00.000Z`;
  // Legacy due fields remain readable on history, but new supplies have no
  // payment-term-derived deadline and must not become overdue payables.
  post.dueDate = null;
  post.dueUpto = "";
  return post;
}
export function prepareRctiIssueDates(document, now = new Date()) {
  const adjustment = Number(document.version) > 1;
  document.supplyDate = validateRctiSupplyDate(
    document.supplyDate,
    now,
    adjustment
  );
  document.rctiDate = `${rctiToday(now)}T00:00:00.000Z`;
  document.dueDate = null;
  document.dueUpto = "";
}
